export interface Off {
  /* off to the right */
  offRight: boolean;
  /* off to the left */
  offLeft: boolean;
  /* off to the bottom */
  offBottom: boolean;
  /* off to the top */
  offTop: boolean;
}

/**
 * Checks if the given element is on the screen.
 */
function isElementVisible(
  /**
   * The element to check.
   */
  el: Element | null,
  {
    partial = true,
    delta = 0
  }: {
    /**
     * Whether to consider the element visible when only a part of it is on the screen.
     */
    partial?: boolean;
    /**
     * The range within the scrollview to consider
     */
    delta?: number;
  } = {}
): { isVisible: false } | (Off & { isVisible: boolean }) {
  if (!el) {
    return { isVisible: false };
  }

  const { top, right, bottom, left, width, height } = el.getBoundingClientRect();

  if (top + right + bottom + left === 0) {
    return { isVisible: false };
  }

  const topCheck = (partial ? top + height : top) + delta;
  const bottomCheck = (partial ? bottom - height : bottom) - delta;
  const rightCheck = (partial ? right - width : right) - delta;
  const leftCheck = (partial ? left + width : left) + delta;

  const windowWidth = window.innerWidth;
  const windowHeight = window.innerHeight;

  return {
    isVisible:
      topCheck >= 0 && leftCheck >= 0 && bottomCheck <= windowHeight && rightCheck <= windowWidth,
    offTop: topCheck >= 0,
    offLeft: leftCheck >= 0,
    offRight: rightCheck <= windowWidth,
    offBottom: bottomCheck <= windowHeight
  };
}
// Adapted from: https://github.com/olistic/react-use-visibility/blob/master/src/checkVisibility.js

export default isElementVisible;
